import React from 'react';
import styled from 'styled-components';

import { GoogleAdsTemplate } from './GoogleAdsTemplate';
const Root = styled.div`
    grid-area: pixel;
`;

export const AdsPixel: React.FC = () => {
    return (
        <Root data-testid="ad-pixel">
            <GoogleAdsTemplate
                adSizes={[['Out-of-page']]}
                idSuffix="pixel"
                network="/30443627/DocPage_1x1"
            />
        </Root>
    );
};
